/* Giftship label presentation only. Cart storage/validation is handled separately
 * by the order-details integration; this file never changes field values/names.
 */
(function () {
  'use strict';
  var selector = '.gs__checkbox-label';
  var replacement = 'Add a card message (optional)';

  function updateLabel(label) {
    if (!label.querySelector('.gs__gift-checkbox')) return;
    label.classList.add('ffg-card-message-toggle');
    label.querySelectorAll('img.gs__checkbox-image').forEach(function (icon) {
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
    });
    var title = label.querySelector('.gs__checkbox-input-title');
    if (title && /^(is this a gift\?|it's a gift\??)$/i.test(title.textContent.trim())) {
      title.textContent = replacement;
    }
  }

  function scan(node) {
    var element = node.nodeType === 1 ? node : node.parentElement;
    if (!element) return;
    var label = element.closest(selector);
    if (label) updateLabel(label);
    element.querySelectorAll(selector).forEach(updateLabel);
  }

  function start() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    scan(main);
    // Handle delayed app insertion and app re-rendering without polling or
    // touching other labels, options, event handlers, or cart data.
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'characterData') scan(record.target);
        else record.addedNodes.forEach(scan);
      });
    }).observe(main, {childList: true, subtree: true, characterData: true});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
}());
